import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Text, Stack } from "braid-design-system";
import { Fragment } from "react";
import { detailList, column1, column2 } from "./DefinitionList.css.mjs";
const generateValueList = (values) => {
  if (values.length > 1) {
    return /* @__PURE__ */ jsx(Stack, { space: "small", component: "ul", children: values.map((value, i) => /* @__PURE__ */ jsx(Text, { component: "li", children: value }, i)) });
  }
  return /* @__PURE__ */ jsx(Text, { children: values[0] });
};
const DefinitionList = ({ data, space = "medium" }) => /* @__PURE__ */ jsx(Box, { component: "dl", className: detailList, children: data.map(({ name, values }, i) => {
  const paddingBottom = i !== data.length - 1 ? space : "none";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "dt",
        className: column1,
        paddingRight: "medium",
        paddingBottom: { mobile: "small", tablet: paddingBottom },
        children: /* @__PURE__ */ jsx(Text, { tone: "secondary", children: name })
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "dd",
        className: column2,
        paddingBottom,
        children: generateValueList(values)
      }
    )
  ] }, i);
}) });
export {
  DefinitionList
};
